import "./DatiPersonaliNonRiconosciutoBusinessPage.css";
import { t } from "../../../services/formatters";
import { Button } from "../../../components/Button";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { FormDatiUtenteBusiness } from "../../../components/FormDatiUtenteBusiness";
import { useDatiPersonaliNonRiconosciutoBusinessPage } from "./useDatiPersonaliNonRiconosciutoBusinessPage";
import { ErrorModal } from "../../../components/ErrorModal";
import { useEffect } from "react";
import { InformativeBusiness } from "../../../components/InformativeBusiness";

export const DatiPersonaliNonRiconosciutoBusinessPage = () => {
  const { next, read, lockFields, isCreaAppuntamentoBusy, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError } = useDatiPersonaliNonRiconosciutoBusinessPage();

  useEffect(() => {
    window.dataLayer.push({
      event: "customPageview",
      virtualPageURL: "/fa3/prestito-business/dati-personali-non-riconosciuto",
      crmIdentification: "nuovo utente",
      funnelVersion: "nuovo",
      faFunnel: "Prestito business",
      capFiliale: read("cap"),
      presa_info: read("solo_info"),
    });
  }, []);

  return (
    <div id="dati-personali-non-riconosciuto-page">
      <Breadcrumb />

      <div className={`section page-title-component center-on-tablet`}>
        <h1>{t("prestito_business")}</h1>
        <div>{t("prestito_business_sottotitolo")}</div>
      </div>

      {/* {read("filialeScelta") && <Riepilogo />} */}
      {lockFields && (
        <div className={`section page-title-component center-on-tablet`}>
          <h1>
            <span>Ciao {read("nome")}!</span>
          </h1>
        </div>
      )}

      <FormDatiUtenteBusiness lockFields={lockFields} title={t("dati_business")} />

      <InformativeBusiness />

      <div className="section text-center">
        <Button id="go-to-select-state-btn" onClick={next} classList="btn-responsive always-style" loading={isCreaAppuntamentoBusy()} text={t("fissa_appuntamento")} />
        {/* {isCreaAppuntamentoError() && <p>errore crea</p>} */}
      </div>

      <ErrorModal
        open={fetchError}
        text={fetchErrorMessage}
        onCloseModal={() => {
          setFetchError(false);
        }}></ErrorModal>
    </div>
  );
};
